var React = require('react');

function ChevronLeft (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z","key":0}),React.createElement("path",{"d":"M0-.5h24v24H0z","fill":"none","key":1})]);
}

ChevronLeft.defaultProps = {"fill":"#000000","height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = ChevronLeft;

ChevronLeft.default = ChevronLeft;



// WEBPACK FOOTER //
// ./src/images/icons/chevron-left.svg